import { useEffect, useState } from "react";
import ChipCrud from "./ChipTable";
import Conect from "../../../../../Api/Conect";
import "./ChipManager.css";

const ChipManager = () => {
  const token = localStorage.getItem("restoken");
  const [operators, setOperators] = useState([]);

  useEffect(() => {
    fetchOperators();
  }, []);

  const fetchOperators = async () => {
    const { data } = await Conect.get(`/b3BlcmF0b3JsaXN0${token}`);
    setOperators(data.data);
  };

  return (

    <ChipCrud token={token} operators={operators} />

  );
};

export default ChipManager;